//* Importing modules
import { useState } from 'react';

//* Importing bootstrap components
import { InputGroup, Form, FormControl } from 'react-bootstrap'; 


//* Importing components
import DefaultButton from "../../../component/base/DefaultButton";

//! Importing APIs
import {AuthAPI} from "../../../services/apis/AuthAPI"; 




type EnterEmailFormProps ={
  setCurrentStep: (step: string) => void;
  email: string;
  setEmail: (email: string) => void;
  message: string;
  setMessage: (message: string) => void;
}

export function EnterEmailForm({
  setCurrentStep,
  email,
  setEmail,
  message,
  setMessage,
}: EnterEmailFormProps) {
  const [loading, setLoading] = useState<boolean>(false);

  const requestResetCode = async () => {
    setLoading(true);
    setMessage("");
    const response = await AuthAPI.requestPasswordReset(email);
    if (response.result) {
      setCurrentStep("verifyCode");
    } else {
      setMessage(response.message);
    }
    setLoading(false);
  };

  return (
    <form
      className="form-horizontal m-t-30"
      onSubmit={(e) => {
        e.preventDefault();
        requestResetCode();
      }}
    >
      <h4 style={{ fontSize: 18 }}>Recuperar Senha</h4>
      <p className="text-muted" style={{ fontSize: 14 }}>
        Insira seu e-mail para receber o código de verificação.
      </p>
      <InputGroup>
        <div className="flex fdcolumn flex1 margin-bottom">
          <Form.Label>E-mail</Form.Label>
          <FormControl
            type="email"
            style={{ fontSize: 14 }}
            placeholder="E-mail"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
      </InputGroup>
      {message && <p style={{ color: "red", fontSize: "0.8rem" }}>{message}</p>}
      <DefaultButton
        type="submit"
        bg="primary"
        width="100%"
        height="3rem"
        style={{ marginTop: "15px" }}
        text="Enviar Código"
        loadingtext="Enviando..."
        loading={loading}
      />
      <div
        style={{
          marginTop: "15px",
          textAlign: "left",
        }}
      >
        <span
          style={{
            fontSize: "0.9rem",
            color: "#007bff",
            cursor: "pointer",
          }}
          onClick={() => setCurrentStep("login")}
        >
          Voltar ao Login
        </span>
      </div>
    </form>
  );
}
